export default "__VITE_ASSET__Cne736Yf__"